<div
  class="ui search selection dropdown"
  [ngClass]="{
    invalid: myFormControl?.errors,
    disabled: disabled || myFormControl.disabled
  }"
  #dropDown
  [attr.tabindex]="tabIndex"
>
  <input
    id="{{ 'question-input-' + question.id }}"
    class="search"
    autocomplete="off"
    [attr.disabled]="disabled"
    [attr.tabindex]="tabIndex"
  />
  <div class="text" [ngClass]="{ default: !myFormControl?.value }"></div>
  <div class="menu"></div>
  <i class="chevron down icon"></i>
</div>

<input
  type="hidden"
  [formControl]="myFormControl"
  [attr.disabled]="disabled"
  [attr.tabindex]="tabIndex"
/>

@if (myFormControl?.errors) {
<div class="clear validation-text">
  @if (myFormControl?.errors?.required) {
  <div>{{ question?.question }} is required</div>
  }
</div>
}
